"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var document_service_1 = require("../document.service");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var http_1 = require("@angular/common/http");
var http_2 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var from_1 = require("rxjs/observable/from");
var zip_1 = require("rxjs/observable/zip");
var of_1 = require("rxjs/observable/of");
var ErrorObservable_1 = require("rxjs/observable/ErrorObservable");
var HttpDocumentService = /** @class */ (function (_super) {
    __extends(HttpDocumentService, _super);
    function HttpDocumentService(http, httpPure, applicationPropertiesService, cookieService, authenticationService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.httpPure = httpPure;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.cookieService = cookieService;
        _this.authenticationService = authenticationService;
        _this.SERVER_TIMESTAMP_URL = 'time';
        _this.DOCUMENT_SERVICE_URI_KEY = 'document-service-url';
        _this.URL_DOCUMENT = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/document/"], ["", "/document/"])), 'serviceUri');
        _this.UPLOAD_DOCUMENT_AUTH = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/document/auth"], ["", "/document/auth"])), 'serviceUri');
        _this.URL_DOCUMENT_UPDATE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", "/document/", ""], ["", "/document/", ""])), 'serviceUri', 'documentId');
        _this.URL_DOCUMENT_INFO = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", "/document/info/", ""], ["", "/document/info/", ""])), 'serviceUri', 'documentId');
        _this.URL_TEMP_DOCUMENT_INFO = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", "/document/info/temp/", ""], ["", "/document/info/temp/", ""])), 'serviceUri', 'documentId');
        _this.URL_DOCUMENT_PRESENT = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", "/document/present/", ""], ["", "/document/present/", ""])), 'serviceUri', 'documentId');
        _this.URL_VALIDATE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", "/validate/document"], ["", "/validate/document"])), 'serviceUri');
        _this.URL_CONFIRM_UPLOAD = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", "/document/", ""], ["", "/document/", ""])), 'serviceUri', 'documentId');
        _this.URL_GET_DOWNLOAD_LINK = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", "/document/tempUrl/", ""], ["", "/document/tempUrl/", ""])), 'serviceUri', 'documentId');
        _this.URL_GET_MULTIPLE_DOWNLOAD_LINK = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", "/document/tempUrl/batch"], ["", "/document/tempUrl/batch"])), 'serviceUri');
        _this.URL_DOWNLOAD = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", "/document/", ""], ["", "/document/", ""])), 'serviceUri', 'tempUrl');
        _this.URL_TEMP_DOWNLOAD = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", "/document/temp/", ""], ["", "/document/temp/", ""])), 'serviceUri', 'id');
        _this.URL_DOCUMENT_DELETE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", "/document/", ""], ["", "/document/", ""])), 'serviceUri', 'documentId');
        return _this;
    }
    HttpDocumentService.prototype.upload = function (categoryId, title, file, metaData) {
        var _this = this;
        if (metaData === void 0) { metaData = null; }
        return from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .pipe(operators_1.mergeMap(function (serviceUri) {
            var url = _this.URL_DOCUMENT.replaceTemplate({
                'serviceUri': serviceUri
            });
            var formData = new FormData();
            formData.append("categoryId", categoryId);
            formData.append("title", title);
            formData.append("file", file, file.name);
            metaData && metaData.forEach(function (value, key) {
                if (!formData.has(key)) {
                    formData.append(key, value);
                }
            });
            return _this.http.post(url, formData)
                .pipe(operators_1.map(function (data) { return data; }));
        }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.uploadWithAuth = function (categoryId, title, file, authInfo, metaData) {
        if (metaData === void 0) { metaData = null; }
        return this.uploadAuth(categoryId, title, file, authInfo, false, metaData)
            .pipe(operators_1.map(function (data) { return data; }));
    };
    HttpDocumentService.prototype.uploadAuthWithProgress = function (categoryId, title, file, authInfo, metaData) {
        if (metaData === void 0) { metaData = null; }
        return this.uploadAuth(categoryId, title, file, authInfo, true, metaData);
    };
    HttpDocumentService.prototype.uploadAuth = function (categoryId, title, file, authInfo, reportProgress, metaData) {
        var _this = this;
        if (reportProgress === void 0) { reportProgress = false; }
        if (metaData === void 0) { metaData = null; }
        return from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .pipe(operators_1.mergeMap(function (serviceUrl) {
            var url = _this.UPLOAD_DOCUMENT_AUTH.replaceTemplate({
                'serviceUri': serviceUrl
            });
            url += "?authInfo=" + authInfo;
            var formData = new FormData();
            formData.append("categoryId", categoryId);
            formData.append("title", title);
            formData.append("file", file, file.name);
            metaData && metaData.forEach(function (value, key) {
                if (!formData.has(key)) {
                    formData.append(key, value);
                }
            });
            var observe = reportProgress ? 'events' : null;
            return _this.http.post(url, formData, { reportProgress: reportProgress, observe: observe });
        }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.validate = function (file) {
        var _this = this;
        return from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .pipe(operators_1.mergeMap(function (serviceUri) {
            var url = _this.URL_VALIDATE.replaceTemplate({
                'serviceUri': serviceUri
            });
            var formData = new FormData();
            formData.append("file", file, file.name);
            return _this.http.post(url, formData);
        }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.confirmUpload = function (documentId, entityId) {
        var _this = this;
        return from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .pipe(operators_1.mergeMap(function (serviceUri) {
            var url = _this.URL_CONFIRM_UPLOAD.replaceTemplate({
                'serviceUri': serviceUri,
                'documentId': documentId.toString()
            });
            return _this.http.put(url, { 'entityId': entityId }).pipe(operators_1.map(function (data) { return data; }));
        }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.getDownloadUrl = function (documentId, authInfo) {
        var _this = this;
        return from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .pipe(operators_1.mergeMap(function (serviceUri) {
            var url = _this.URL_GET_DOWNLOAD_LINK.replaceTemplate({
                'serviceUri': serviceUri,
                'documentId': documentId.toString()
            });
            url += "?authInfo=" + authInfo;
            return _this.http.get(url).pipe(operators_1.map(function (data) { return data['tempUrl']; }));
        }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.getDownloadUrls = function (documentIds, authInfo) {
        var _this = this;
        return from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .pipe(operators_1.mergeMap(function (serviceUri) {
            var url = _this.URL_GET_MULTIPLE_DOWNLOAD_LINK.replaceTemplate({
                'serviceUri': serviceUri
            });
            url += "?documentIds=" + documentIds.join(',');
            url += "&authInfo=" + authInfo;
            return _this.http.get(url).pipe(operators_1.map(function (data) {
                var urls = new Map();
                for (var key in data) {
                    if (data.hasOwnProperty(key)) {
                        urls.set(Number(key), data[key]);
                    }
                }
                return urls;
            }));
        }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.downloadDocument = function (tempUrl, fileType) {
        var _this = this;
        zip_1.zip(from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY)), this.authenticationService.getUserData(), this.httpPure.get(this.SERVER_TIMESTAMP_URL).pipe(operators_1.map(function (data) {
            if (typeof data === 'object' && Object.getOwnPropertyNames(data).indexOf('time') != -1) {
                return data['time'];
            }
            return 0;
        }), operators_1.catchError(function () { return of_1.of(0); }))).subscribe(function (_a) {
            var serviceUri = _a[0], currentUserData = _a[1], serverTime = _a[2];
            var url = _this.URL_DOWNLOAD.replaceTemplate({
                'serviceUri': serviceUri,
                'tempUrl': tempUrl
            });
            // add userID parameter
            url = url + "?userID=" + currentUserData.userId;
            // add time parameter if exist
            if (serverTime) {
                url = url + "&time=" + serverTime;
            }
            // add fileType parameter if exist
            if (fileType) {
                url = url + "&fileType=" + fileType;
            }
            // add access_token parameter
            url = "" + url + _this.getAccessToken('&');
            window.open(url);
        });
    };
    HttpDocumentService.prototype.downloadTempDocument = function (id) {
        var _this = this;
        from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .subscribe(function (serviceUri) {
            var url = _this.URL_TEMP_DOWNLOAD.replaceTemplate({
                'serviceUri': serviceUri,
                'id': id.toString()
            });
            url = "" + url + _this.getAccessToken('?');
            window.open(url);
        });
    };
    HttpDocumentService.prototype.getDocumentUrl = function (documentId, authInfo, fileType) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(documentId);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(authInfo);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(fileType);
        return zip_1.zip(this.getDownloadUrl(documentId, authInfo), from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))).pipe(operators_1.map(function (_a) {
            var tempUrl = _a[0], serviceUri = _a[1];
            var url = _this.URL_DOWNLOAD.replaceTemplate({
                'serviceUri': serviceUri,
                'tempUrl': tempUrl
            });
            return url + "?fileType=" + fileType + _this.getAccessToken('&');
        }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.getTempDocumentUrl = function (documentId, fileType) {
        var _this = this;
        return from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .pipe(operators_1.map(function (serviceUri) {
            var url = _this.URL_TEMP_DOWNLOAD.replaceTemplate({
                'serviceUri': serviceUri,
                'id': documentId.toString()
            });
            if (fileType) {
                return url + "?fileType=" + fileType + _this.getAccessToken('&');
            }
            return "" + url + _this.getAccessToken('?');
        }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.getTempDocumentInfo = function (documentId) {
        var _this = this;
        return from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .pipe(operators_1.mergeMap(function (serviceUri) {
            var url = _this.URL_TEMP_DOCUMENT_INFO.replaceTemplate({
                'serviceUri': serviceUri,
                'documentId': documentId.toString()
            });
            return _this.http.get(url);
        }), operators_1.map(function (data) { return data; }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.getDocumentInfo = function (documentId) {
        var _this = this;
        return from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .pipe(operators_1.mergeMap(function (serviceUri) {
            var url = _this.URL_DOCUMENT_INFO.replaceTemplate({
                'serviceUri': serviceUri,
                'documentId': documentId.toString()
            });
            return _this.http.get(url);
        }), operators_1.map(function (data) { return data; }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.getDocumentsByEntityId = function (categoryId, entityId) {
        var _this = this;
        return from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .pipe(operators_1.mergeMap(function (serviceUri) {
            var url = _this.URL_DOCUMENT.replaceTemplate({
                'serviceUri': serviceUri
            });
            var params = new http_1.HttpParams()
                .set('categoryId', categoryId)
                .set('entityId', entityId.toString());
            return _this.http.get(url, { params: params });
        }), operators_1.map(function (data) { return data; }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.deleteDocumentById = function (documentId) {
        var _this = this;
        return from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .pipe(operators_1.mergeMap(function (serviceUri) {
            var url = _this.URL_DOCUMENT_DELETE.replaceTemplate({
                'serviceUri': serviceUri,
                'documentId': documentId.toString()
            });
            return _this.http.delete(url);
        }), operators_1.map(function (_) { return true; }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.getIsDocumentPresent = function (documentId) {
        var _this = this;
        return from_1.from(this.applicationPropertiesService.getProperty(this.DOCUMENT_SERVICE_URI_KEY))
            .pipe(operators_1.mergeMap(function (serviceUri) {
            var url = _this.URL_DOCUMENT_PRESENT.replaceTemplate({
                'serviceUri': serviceUri,
                'documentId': documentId.toString()
            });
            return _this.http.get(url);
        }), operators_1.catchError(this.handleError));
    };
    HttpDocumentService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        }
        else if (typeof error.error === 'object') {
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error.reason));
        }
        else {
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        return new ErrorObservable_1.ErrorObservable(error);
    };
    HttpDocumentService.prototype.getAccessToken = function (prefix) {
        var access_token = this.cookieService.get('access_token');
        return access_token && prefix + "access_token=" + access_token;
    };
    HttpDocumentService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            http_2.HttpClient,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_authentication_client_js_1.CookieService,
            idm_authentication_client_js_1.AuthenticationService])
    ], HttpDocumentService);
    return HttpDocumentService;
}(document_service_1.DocumentService));
exports.HttpDocumentService = HttpDocumentService;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;
//# sourceMappingURL=http.document.service.js.map